module.exports = __webpack_public_path__ + "img/part9-5.e83e83a6.png";